import { render, staticRenderFns } from "./OpenRegistrationPageError.vue?vue&type=template&id=8111109e"
import script from "./OpenRegistrationPageError.vue?vue&type=script&lang=js"
export * from "./OpenRegistrationPageError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports